import {
  IconAnalytics,
  IconBell,
  IconCar,
  IconChainLinkGray,
  IconChartBar,
  IconChartBarGray,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconPenSquare,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconShareGray,
  IconWarning,
} from '@assets/images/icon';
import { rtlsSystem3 } from '@assets/images/solution';
import video from '@src/assets/images/solution/retailExhibition/video/rtlsVideo.mp4';

import subVideo1 from '@src/assets/images/solution/retailExhibition/video/sub/rtlsVideo1.mp4';
import subVideo2 from '@src/assets/images/solution/retailExhibition/video/sub/rtlsVideo2.mp4';
import subVideo3 from '@src/assets/images/solution/retailExhibition/video/sub/rtlsVideo3.mp4';

import image1 from '@src/assets/images/solution/retailExhibition/img/1.avif';
import image2 from '@src/assets/images/solution/retailExhibition/img/2.avif';
import image3 from '@src/assets/images/solution/retailExhibition/img/3.avif';
import image4 from '@src/assets/images/solution/retailExhibition/img/4.avif';
import image5 from '@src/assets/images/solution/retailExhibition/img/5.avif';
import {
  recommendationAiServer,
  recommendationEdge,
  recommendationServer,
  recommendationSwitch,
  retailExhibition1,
  retailExhibition2,
  retailExhibition3,
} from '@assets/images/solution/recommendation';
import recommendation from '../common/recommendation';

export default {
  type: '리테일 솔루션',

  banner: {
    title: '관람객의 동선을 실시간으로 분석해 전시 효과를 객관적으로 평가하세요',
    desc: '방문증으로 관람객의 체류 시간과 이동 경로를 기록하고 작품별 반응을 데이터로 분석합니다',
  },

  recommend: {
    title: '관람객의 위치를 추적하고 이동 경로와 체류 데이터를 기록합니다',
    desc: '관람객에게 제공된 위치 태그가 실내 리더기에 의해 감지되어, 이동 흐름과 체류 시간이 자동으로 수집됩니다',
    labels: {
      desktop: [
        {
          img: retailExhibition1,
          data: recommendation.ipCamera,
        },
        {
          img: retailExhibition2,
          data: recommendation.uwbTag,
        },
        {
          img: retailExhibition3,
          data: recommendation.idCard,
        },
        {
          img: recommendationServer,
          data: recommendation.server,
        },
        {
          img: recommendationAiServer,
          data: recommendation.aiServer,
        },
        {
          img: recommendationEdge,
          data: recommendation.edgeRtls,
        },
        {
          img: recommendationSwitch,
          data: recommendation.switch,
        },
      ],
      mobile: [
        {
          data: recommendation.idCard,
        },
        {
          data: recommendation.twintarckerUWB,
        },
        {
          data: recommendation.ipCamera,
        },
        {
          data: recommendation.server,
        },
        {
          data: recommendation.aiServer,
        },
        {
          data: recommendation.edgeRtls,
        },
        {
          data: recommendation.switch,
        },
      ],
    },
  },

  video: {
    title: '작품 앞에 서는 순간, 자동으로 작품에 대한 안내가 시작됩니다.',
    desc: '관람객이 작품 근처에 다가가면 자동으로 해당 작품의 설명이 제공됩니다. 안내 인력이 없어도 관람객은 원하는 작품에 대해 즉시 이해할 수 있어, 더욱 몰입감 있고 편리한 미술관 관람을 경험할 수 있습니다.',
    play: video,
  },

  func: [
    {
      theme: '관람객 위치에 따라 작품 안내를 자동으로 제공합니다.',
      title: '관람객의 위치 실시간 확인',
      desc: '관람객이 착용한 목걸이형 UWB 태그로 위치를 ±20cm 내 정밀도로 추적합니다. 관람객의 위치를 실시간으로 파악하여 작품에 가까워졌을 때 즉시 안내를 시작합니다.',
      sub1: '실시간 현황 파악',
      icon1: IconClockGray,
      sub2: '빠른 데이터 연동',
      icon2: IconShareGray,
      video: subVideo1,
    },
    {
      title: '작품 접근 시 자동 맞춤 안내',
      desc: '관람객이 특정 작품 앞에 가까이 다가가면 자동으로 작품 설명이 시작됩니다. 관람객은 별도의 조작 없이 작품에 대한 깊이 있는 정보를 얻을 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '높은 정확도 제공',
      icon2: IconRulerGray,
      image: image1,
    },
    {
      title: '방문증을 이용한 이동경로 분석',
      desc: '관람객이 착용한 방문증으로 이동 경로와 체류 데이터를 분석하여 관람객의 실제 관심도를 파악합니다. 이를 통해 전시 콘텐츠 기획과 전시 효과를 극대화할 수 있습니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '빠른 데이터 연동',
      icon2: IconChainLinkGray,
      image: image2,
    },
    {
      title: '위험구역 접근 시 즉시 알림',
      desc: '관람객이 펜스를 넘거나 접근 제한 구역에 진입할 경우, 즉시 관리자에게 알림이 전달됩니다. 실시간 모니터링을 통해 안전사고 위험을 사전에 방지할 수 있습니다.',
      sub1: '높은 정확도 제공',
      icon1: IconRulerGray,
      sub2: '빠른 데이터 연동',
      icon2: IconChainLinkGray,
      video: subVideo3,
    },
    {
      theme: '관람 데이터를 활용하여 전시 운영을 효율적으로 관리하세요.',
      title: '전시 작품별 관심도 자동 분석',
      desc: '관람객이 가장 많이 체류한 장소를 히트맵으로 시각화하여 공간 점유율을 직관적으로 분석할 수 있습니다. 이를 통해 인기 있는 공간과 전시 콘텐츠를 명확히 파악할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: '데이터 기반 콘텐츠 기획 지원',
      desc: '관람객의 이동 경로와 체류 데이터를 분석하여 향후 전시 콘텐츠 기획에 실질적으로 활용할 수 있습니다. 관람객의 실제 관심도를 반영하여 전시 효과를 극대화합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      video: subVideo2,
    },
    {
      title: '스토어 내 상품 선호도 자동 분석',
      desc: '전시관 내 기념품 스토어에서 방문객의 체류 시간과 이동 경로 데이터를 분석하여 상품별 선호도를 객관적으로 측정합니다. 이를 통해 상품 구성을 최적화하고 매출을 증대시킬 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: '공간배치 최적화 지원',
      desc: '관람객 밀집 데이터를 기반으로 실시간 운영 인력 배치가 가능하며, 인력 효율을 극대화하여 운영 비용을 절감할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image5,
    },
  ],
  subfunc: {
    title: '기능 요약',
    desc: '',

    data: [
      {
        icon: IconRoute, // 위치 추적 → Route: 이동 경로 의미
        title: '관람객 위치추적',
        desc: '관람객의 실시간 위치를 추적해 전시 흐름을 데이터로 분석합니다.',
      },
      {
        icon: IconLayers, // 자동 안내 → 콘텐츠 안내/정보 표출 → Layers 재사용
        title: '작품 자동 안내',
        desc: '관람객이 작품 앞에 도달하면 콘텐츠 설명이 자동으로 시작돼 몰입도를 높입니다.',
      },
      {
        icon: IconAnalytics, // 이동/체류 분석 → 데이터 분석 의미
        title: '이동 및 체류 분석',
        desc: '이동 경로와 작품별 체류 시간을 수치화해 콘텐츠 반응을 평가합니다.',
      },
      {
        icon: IconWarning, // 위험구역 접근 → 경고 알림
        title: '위험구역 접근 감지',
        desc: '제한 구역에 접근 시 관리자에게 즉시 알림을 전송해 안전 대응을 지원합니다.',
      },
      {
        icon: IconAnalytics, // 히트맵 → 데이터 기반 시각화
        title: '관심도 히트맵 시각화',
        desc: '작품별 체류 시간을 기반으로 관심 구역을 히트맵 형태로 시각화합니다.',
      },
      {
        icon: IconSearch, // 콘텐츠 기획 → 전략 탐색/설계 의미
        title: '데이터 기반 콘텐츠 기획',
        desc: '관람 데이터를 기반으로 큐레이션과 콘텐츠 전략 수립에 필요한 인사이트를 제공합니다.',
      },
      {
        icon: IconCar, // 스토어 분석 → 상품/선호도 분석을 위한 임시 활용
        title: '스토어 선호도 분석',
        desc: '기념품 스토어 내 체류 데이터를 분석해 상품별 선호도를 자동 측정합니다.',
      },
      {
        icon: IconLayers, // 인력 배치 → 공간/밀집 기반 → Layers 적합
        title: '밀집도 기반 인력배치',
        desc: '관람객 밀집도를 분석해 혼잡 구간에 인력을 배치하고 운영 효율을 높입니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem3,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'peoplePackage',
    },
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'manufacturingSteel',
    },
    {
      data: 'logisticsSafety',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
